import * as angular from "angular";
import template from "./view-modes-mode.html";
import { ViewModeActionHandle } from "./viewModeActionHandle";
import type { ViewModeHandle } from "./viewModeHandle";
import type { ViewModesSectionController } from "./view-modes-section";
import type {
	ViewModeActionDefinition,
	ViewModeDefinition
} from "./view-modes-section-types";

export const viewModesModeTransclude = {
	actions: "?viewModeActions",
	content: "viewModeContent"
};

export interface ViewModesModeController extends ViewModeDefinition {
	section: ViewModesSectionController;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class ViewModesModeController {
	private modeHandle?: ViewModeHandle;

	public $onInit(): void {
		this.modeHandle = this.section.modes.add(this);
	}

	public isActive(): boolean {
		return this.modeHandle === this.section.activeMode;
	}

	public registerAction(action: ViewModeActionDefinition): ViewModeActionHandle {
		if(!this.modeHandle) {
			throw new Error("view-mode-action cannot register before its view-modes-mode.");
		}

		return this.modeHandle.addAction(action);
	}
}

export default angular
	.module("vesl.components.view-modes-section.mode", [])
	.component("viewModesMode", {
		template,
		transclude: viewModesModeTransclude,
		controller: ViewModesModeController,
		bindings: {
			code: "@",
			available: "<?",
			disabled: "<?",
			loading: "<?isLoading",
			dirtyCheck: "&?isDirty",
			onEnter: "&?",
			onLeave: "&?"
		},
		require: {
			section: "^^viewModesSection"
		}
	})
	.name;
